var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"remove-icon",class:{[_vm.type]: true},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"nexd-icon-16-close-small",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }